import { z } from 'zod';
import { templateBaseSchema } from './base';

const widgetTypeSchema = z.enum([
  'paragraph',
  'input',
  'numberInput',
  'textarea',
  'select',
  'numberSelect',
  'searchableSelect',
  'checkbox',
  'radio',
  'datePicker',
  'dateRangePicker',
  'timePicker',
]);

const templateTableColumnV1Schema = z.object({
  id: z.string(),
  widgetType: widgetTypeSchema,
  title: z.string(),
  isTitleRequired: z.boolean(),
  width: z.number().optional(),
  // 選項內容：僅當 widgetType 為 select/searchableSelect/checkbox/radio 時使用
  options: z
    .array(
      z.object({
        id: z.string(),
        label: z.string(),
        value: z.string(),
      }),
    )
    .optional(),
  defaultValue: z.string().optional(),
});

const templateTableRowV1Schema = z.object({
  rowId: z.string(),
});

export const templateTableSchema = templateBaseSchema.extend({
  type: z.literal('table'),
  name: z.string(),
  showTitle: z.boolean(),
  columns: z.array(templateTableColumnV1Schema),
  rows: z.array(templateTableRowV1Schema),
  selectedColumnId: z.string().optional(),
  values: z.record(
    z.string(), // rowId 作為 key
    z.record(
      z.string(), // columnId 作為 key
      z
        .union([
          z.string(),
          z.array(z.string()), // checkbox
          z.object({
            from: z.string().nullable(),
            to: z.string().nullable(),
          }), // dateRangePicker
        ])
        .nullable(),
    ),
  ),
});

export type TemplateTableColumnV1 = z.infer<typeof templateTableColumnV1Schema>;
export type TemplateTableRowV1 = z.infer<typeof templateTableRowV1Schema>;
export type TemplateTableV1 = z.infer<typeof templateTableSchema>;
